import { zetActieveOmgeving } from '../lib/omgeving.js';

// Nette, vaste labels; een onbekende sleutel valt terug op de sleutel met hoofdletter.
const LABELS = {
  arnhem_eo: 'Arnhem e.o.',
  maastricht: 'Maastricht',
};

function labelVoor(sleutel) {
  return LABELS[sleutel] ?? (sleutel.charAt(0).toUpperCase() + sleutel.slice(1));
}

/**
 * Omgeving-wisselaar in de header. Rendert NIETS zolang iemand in <= 1 omgeving zit, dus
 * voor een gewone gebruiker verandert er niets aan het scherm.
 *
 * Bij een wissel: onthoud de nieuwe omgeving (localStorage) en HERLAAD de pagina.
 * KRITIEK — de reload is bewust: de zustand-persist leest zijn per-omgeving localStorage-
 * bucket alleen bij het opstarten (createJSONStorage met omgevingStorage), terwijl schrijven
 * meteen naar de nieuwe bucket gaat. Zonder reload zou de store data van de ene omgeving in
 * de bucket van de andere schrijven.
 */
export default function OmgevingKiezer({ omgevingen, actieveOmgeving }) {
  if (!Array.isArray(omgevingen) || omgevingen.length <= 1) return null;

  const kies = (sleutel) => {
    if (!sleutel || sleutel === actieveOmgeving) return; // zelfde omgeving -> geen wissel
    zetActieveOmgeving(sleutel);
    window.location.reload();
  };

  return (
    <select
      value={actieveOmgeving ?? ''}
      onChange={(e) => kies(e.target.value)}
      aria-label="Kies omgeving"
      className="px-3 py-1.5 rounded-md text-sm font-medium text-brand-100 hover:text-white hover:bg-white/10 transition-colors bg-transparent cursor-pointer focus:outline-none"
    >
      {omgevingen.map((o) => (
        <option key={o.sleutel} value={o.sleutel} className="text-slate-800">
          {labelVoor(o.sleutel)}
        </option>
      ))}
    </select>
  );
}
